import React, { createContext, useCallback, useContext, useState } from 'react';

interface EventsProps {
    aboutLoad: string;
    serviceLoad: string;
    contactValue: number;
    queryAttention: any;
    changeAboutLoad: (title: string) => void;
    changeServiceLoad: (title: string) => void;
    reset: () => void;
    contactValueHandler: (value: number) => void;
    queryAttentionHandler: (attention: any) => void;
}

const initialState: EventsProps = {
    aboutLoad: 'default',
    serviceLoad: 'default',
    contactValue: 0,
    queryAttention: 'Prispek',
    changeAboutLoad: () => {},
    changeServiceLoad: () => {},
    reset: () => {},
    contactValueHandler: () => {},
    queryAttentionHandler: () => {}
};

export const EventsContext = createContext<EventsProps>(initialState);

export const EventsContextProvider: React.FC<{ children: React.ReactNode }> = ({
    children
}) => {
    const [aboutLoad, setAboutLoad] = useState<string>('default');
    const [serviceLoad, setServiceLoad] = useState<string>('default');
    const [contactValue, setContactValue] = useState(0);
    const [queryAttention, setQueryAttention] = useState<any>('Prispek');

    const changeAboutLoad = useCallback((title: string) => setAboutLoad(title), []);

    const changeServiceLoad = useCallback(
        (title: string) => setServiceLoad(title),
        []
    );

    const reset = useCallback(() => {
        setAboutLoad('default');
        setContactValue(0);
        setQueryAttention('Prispek');
    }, []);

    const contactValueHandler = useCallback(value => setContactValue(value), []);

    const queryAttentionHandler = useCallback(
        attention => setQueryAttention(attention),
        []
    );

    return (
        <EventsContext.Provider
            value={{
                aboutLoad,
                contactValue,
                changeAboutLoad,
                queryAttention,
                serviceLoad,
                changeServiceLoad,
                reset,
                contactValueHandler,
                queryAttentionHandler
            }}
        >
            {children}
        </EventsContext.Provider>
    );
};

export const useEvents = () => useContext(EventsContext);
